// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'C:/MyWork/new_work/chatbi-frontend/node_modules/.pnpm/@umijs+renderer-react@4.6.1_7b1eca13aea43eb589e1244965d4888b/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
